import { readSheet } from 'read-excel-file/browser';
import writeExcelFile from 'write-excel-file/browser';

import {
  objectsToSpreadsheetRows,
  spreadsheetRowsToObjects,
} from './spreadsheet-data';

export async function readSpreadsheetObjects(file: Blob) {
  const rows = await readSheet(file);
  return spreadsheetRowsToObjects(rows);
}

export async function downloadSpreadsheet(
  fileName: string,
  sheetName: string,
  objects: readonly Record<string, unknown>[],
  columns?: readonly string[],
) {
  const rows = objectsToSpreadsheetRows(objects, columns);
  await writeExcelFile(rows, { sheet: sheetName }).toFile(fileName);
}
